import { cn } from '@/utils/cn';
import { useAvatar } from '@/features/profile/contexts/AvatarContext';

interface AvatarProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  onClick?: () => void;
}

const Avatar = ({ size = 'md', className, onClick }: AvatarProps) => {
  const { selectedAvatar, getAvatarDisplay } = useAvatar();
  
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const avatarUrl = getAvatarDisplay(selectedAvatar);

  return (
    <div className="relative">
      <button
        onClick={onClick}
        disabled={!onClick}
        className={cn(
          'rounded-full flex items-center justify-center font-bold transition-all duration-200 overflow-hidden border-2 border-white shadow-sm',
          sizeClasses[size],
          onClick && 'hover:scale-105 cursor-pointer',
          !onClick && 'cursor-default',
          className
        )}
      >
        <img 
          src={avatarUrl} 
          alt="User Avatar"
          className="w-full h-full object-cover rounded-full"
          onError={(e) => {
            // Fallback to default letter if image fails to load
            const target = e.currentTarget;
            const fallback = target.nextElementSibling as HTMLElement;
            if (fallback) {
              target.style.display = 'none';
              fallback.style.display = 'flex';
            }
          }}
        />
        <div 
          className="w-full h-full rounded-full bg-primary-500 text-white flex items-center justify-center font-bold text-lg hidden"
        >
          K
        </div>
      </button>
      

    </div>
  );
};

export default Avatar;
